import dashboardPanelView from "Modules/dashboard/views/dashboardPanel/lan/en";

const locales = {
    ...dashboardPanelView
};

export default locales;